
import React from "react";

interface SiteMetaInfoProps {
  siteName: string;
  city: string;
  phone?: string;
  email?: string;
  website?: string;
}

const SiteMetaInfo: React.FC<SiteMetaInfoProps> = ({
  siteName,
  city,
  phone,
  email,
  website
}) => {
  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
        {phone && (
          <div className="flex items-center gap-2">
            <span className="text-fabre-lightgreen font-medium">Téléphone:</span>
            <a href={`tel:${phone}`} className="text-white hover:text-fabre-lightgreen transition-colors">
              {phone}
            </a>
          </div>
        )}
        {email && (
          <div className="flex items-center gap-2">
            <span className="text-fabre-lightgreen font-medium">Email:</span>
            <a href={`mailto:${email}`} className="text-white hover:text-fabre-lightgreen transition-colors">
              {email}
            </a>
          </div>
        )}
        {website && (
          <div className="flex items-center gap-2">
            <span className="text-fabre-lightgreen font-medium">Site web:</span>
            <a 
              href={website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-fabre-lightgreen transition-colors"
            >
              Visiter
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default SiteMetaInfo;
